import { emptyAdminApi as api } from "../emptyAdminApi";
import {
  CreatePromotionRequest,
  CreatePromotionResponse,
  DeletePromotionRequest,
  DeletePromotionResponse,
  GetPromotionRequest,
  GetPromotionResponse,
  ListPromotionsResponse,
  UpdatePromotionConfigRequest,
  UpdatePromotionConfigResponse,
  UpdatePromotionStatusRequest,
  UpdatePromotionStatusResponse,
} from "./Promotion";

export const addTagTypes = ["Promotions"] as const;

const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      /**
       * LIST
       * GET /webshop/promo/manage
       */
      getPromos: build.query<ListPromotionsResponse, void>({
        query: () => ({
          url: "/webshop/promo/manage",
          method: "GET",
        }),
        providesTags: ["Promotions"],
      }),
       getPromosByType: build.query<ListPromotionsResponse, string>({
        query: (type) => ({
          url: "/webshop/promo/manage?type=" + encodeURIComponent(type),
          method: "GET",
        }),
        providesTags: ["Promotions"],
      }),

      /**
       * READ ONE
       * GET /webshop/promo/manage?promoCode=CODE
       */
      getPromoById: build.query<GetPromotionResponse, GetPromotionRequest>({
        query: (p) => ({
          url: "/webshop/promo/manage?promoCode=" + encodeURIComponent(p.promoCode),
          method: "GET",
        }),
        providesTags: ["Promotions"],
      }),

      /**
       * CREATE
       * POST /webshop/promo/manage
       */
      createPromo: build.mutation<CreatePromotionResponse, CreatePromotionRequest>({
        query: (body) => ({
          url: "/webshop/promo/manage",
          method: "POST",
          body,
        }),
        invalidatesTags: ["Promotions"],
      }),

      /**
       * UPDATE CONFIG
       * PUT /webshop/promo/manage
       */
      updatePromoConfig: build.mutation<
        UpdatePromotionConfigResponse,
        UpdatePromotionConfigRequest
      >({
        query: (body) => ({
          url: "/webshop/promo/manage",
          method: "PUT",
          body,
        }),
        invalidatesTags: ["Promotions"],
      }),

      /**
       * UPDATE STATUS
       * PUT /webshop/promo/manage?action=status
       */
      updatePromoStatus: build.mutation<
        UpdatePromotionStatusResponse,
        UpdatePromotionStatusRequest
      >({
        query: (body) => ({
          url: "/webshop/promo/manage?action=status",
          method: "PUT",
          body,
        }),
        invalidatesTags: ["Promotions"],
      }),

      /**
       * DELETE
       * DELETE /webshop/promo/manage?id=PROMOCODE
       * (Yes: query param is "id" in the code, and it expects promoCode value.)
       */
      deletePromo: build.mutation<DeletePromotionResponse, DeletePromotionRequest>({
        query: (p) => ({
          url: "/webshop/promo/manage?id=" + encodeURIComponent(p.id),
          method: "DELETE",
        }),
        invalidatesTags: ["Promotions"],
      }),
    }),
  });

export const {
  useGetPromosQuery,
  useGetPromoByIdQuery,
  useGetPromosByTypeQuery,
  useCreatePromoMutation,
  useUpdatePromoConfigMutation,
  useUpdatePromoStatusMutation,
  useDeletePromoMutation,
} = injectedRtkApi;

export { injectedRtkApi };
